import { render, staticRenderFns } from "./GrievancePage.vue?vue&type=template&id=acb0d0ee&scoped=true&"
import script from "./GrievancePage.vue?vue&type=script&lang=ts&"
export * from "./GrievancePage.vue?vue&type=script&lang=ts&"
import style0 from "./GrievancePage.vue?vue&type=style&index=0&id=acb0d0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb0d0ee",
  null
  
)

/* custom blocks */
import block0 from "./GrievancePage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports